module.exports = __webpack_public_path__ + "static/media/download.c473f829.svg";